const frameworks = [
  "React.js",
  "Bootstrap",
  "Node.js",
  "FastAPI",
  "Flask",
  "gRPC",
];

export default frameworks;